//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { createStyles, LinearProgress, makeStyles, withStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from './common/contexts';
import { setClassNameInDefns } from './common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import Logo from './system/Logo';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import Header from './subComponents/Header';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
    pageContainer: { backgroundColor: '#FAFAFC', overflow: 'hidden', height: '100vh', minHeight: '100%', flexWrap: 'unset' },
    // pageHeader: {
    //     maxHeight: '81px',
    //     // [theme.breakpoints.down('md')]: { maxHeight: '134px' }, // commented out because no more second row menu -el 20221022
    //     // [theme.breakpoints.down('sm')]: { maxHeight: '81px' },
    // },
    pageContent: {
        flex: 1,
        overflowY: 'hidden',
        // overflowY: 'auto',
        // overflowX: 'hidden',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    appLogoContainer: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        textAlign: 'center',
    },
    appLogo: {
        width: '20%',
        minWidth: 200,
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        pageContainer: { container: true, direction: 'column' },
        // pageHeader: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        pageContent: { item: true, container: true, justifyContent: 'center', alignContent: 'center' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const BorderLinearProgress = withStyles(theme =>
    createStyles({
        root: {
            height: 5,
            borderRadius: 3,
        },
        colorPrimary: {
            backgroundColor: '#FFF',
        },
        bar: {
            borderRadius: 5,
            backgroundColor: '#FC821F',
        },
    }),
)(LinearProgress);

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const LaunchScreen = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    // const appContext = useContext(AppContext);
    const context = useContext(LayoutContext);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { isShowProgressBar } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [homePageId, setHomePageId] = useState(HOMEPAGE_LANDING);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    // const contentWrapperEl = _get(pageContentSimpleBarEl, 'current.contentWrapperEl');
    // const contentEl = _get(pageContentSimpleBarEl, 'current.contentEl');

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider value={{ ...context }}>
            <Grid {...defns.pageContainer}>
                {isShowProgressBar && <BorderLinearProgress {...defns.progress} />}
                <Grid {...defns.pageContent}>
                    <div {...defns.appLogoContainer}>
                        <Logo {...defns.appLogo} />
                    </div>
                </Grid>
            </Grid>
        </LayoutContext.Provider>
    );
};

export default LaunchScreen;
